import { useState, useEffect } from 'react';
import { loadKeypadScripts } from 'utils/keypadScriptsLoad';

export const useLoadKeypadScripts = () => {
  const [isKeypadScriptReady, setIsKeypadScriptReady] = useState(false);

  useEffect(() => {
    let canceled = false;

    loadKeypadScripts()
      .then(() => {
        if (!canceled) setIsKeypadScriptReady(true);
      })
      .catch((error: Error) => {
        console.error(error.message);
      });

    return () => {
      canceled = true;
    };
  }, []);

  return { isKeypadScriptReady };
};
